/**
 * Arama sonuç sayfasını, öngörülü arama kutusuyla aynı alan kapsamına sokar.
 *
 * Shopify'ın tam metin araması ürün açıklamasında da eşleşiyor ve gevşek
 * eşleme yapıyor: "libelle" 47 sonuç döndürüyordu, ilk 8'i doğru, sonrası
 * "mayoral ... lila", "lilipinso ..." gibi alakasız ürünlerdi. Öngörülü arama
 * (/search/suggest.json) yalnızca title / product_type / vendor / tag
 * alanlarına baktığı için 10 sonucun 10'u da doğru geliyordu.
 *
 * Burada aynı kapsamı /search üzerinde kuruyoruz. Enter'a basıldığında sorgu
 * Shopify'ın alan sözdizimine çevriliyor:
 *
 *   libelle -> (title:libelle* OR product_type:libelle* OR vendor:libelle* OR tag:libelle*)
 *
 * Sonuç sayfası server-side kaldığı için filtre, sıralama ve sayfalama
 * çalışmaya devam ediyor. Kullanıcının yazdığı terim `sq` parametresinde
 * taşınıyor; arama kutusu ve başlıklar bu terimden geri yazılıyor.
 */
(function () {
  if (window.searchQueryScope) return;

  var FIELDS = ['title', 'product_type', 'vendor', 'tag'];
  var DISPLAY_PARAM = 'sq';
  var SEARCH_FORM = 'form[role="search"]:not(.face-form)';
  var SCOPED_PATTERN = /(?:^|[\s(])(?:title|product_type|vendor|tag|variants\.sku|body):/i;
  var PRESERVED_PARAMS = ['preview_theme_id', '_ab', '_fd', '_sc'];
  var BROAD_PARAM = 'all'; // kapsamı bilerek devre dışı bırakır

  // Shopify arama sözdiziminde anlamı olan karakterleri ayıklar ve sorguyu
  // kelimelere böler. Tire kelime ayırıcı sayılıyor: "tripp-trapp" iki terim
  // olarak aranıyor, çünkü tire başta NOT anlamına geliyor.
  function words(terms) {
    return terms
      .replace(/[-"():*~^\\/]/g, ' ')
      .split(/\s+/)
      .filter(function (word) {
        return word.length > 0 && !/^(AND|OR|NOT)$/i.test(word);
      });
  }

  function scope(terms) {
    var parts = words(terms);
    if (!parts.length) return '';

    return parts
      .map(function (word) {
        return (
          '(' +
          FIELDS.map(function (field) {
            return field + ':' + word + '*';
          }).join(' OR ') +
          ')'
        );
      })
      .join(' AND ');
  }

  function isScoped(query) {
    return SCOPED_PATTERN.test(query);
  }

  function scopedUrl(path, terms) {
    var query = scope(terms);
    if (!query) return null;

    var params = new URLSearchParams();
    params.set('q', query);
    params.set('type', 'product');
    params.set(DISPLAY_PARAM, terms);
    carryOverPreview(params);
    return path + '?' + params.toString();
  }

  // Tema önizleme parametreleri yeni sorguya taşınmalı, yoksa önizleme
  // linkinden yapılan arama yayındaki temaya düşüyor.
  function carryOverPreview(params) {
    var current = new URLSearchParams(window.location.search);

    PRESERVED_PARAMS.forEach(function (name) {
      var value = current.get(name);
      if (value) params.set(name, value);
    });
  }

  function param(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  // Kapsamlı sorgudan kullanıcının yazdığı terimleri geri çözer.
  // Sayfalama, filtre ve sıralama bağlantıları `sq` parametresini taşımadığı
  // için ikinci sayfada tek kaynak bu.
  function termsFromQuery(query) {
    var matches = query.match(/title:[^\s*)]+\*/g);
    if (!matches) return '';

    return matches
      .map(function (match) {
        return match.slice('title:'.length, -1);
      })
      .join(' ');
  }

  // Önce kullanıcının yazdığı hali, yoksa sorgudan çözülmüş hali.
  function displayTerms() {
    var terms = param(DISPLAY_PARAM);
    if (terms) return terms;

    var raw = param('q');
    return raw && isScoped(raw) ? termsFromQuery(raw) : '';
  }

  // Enter ve "tüm sonuçları görün" butonu buradan geçiyor; ikisi de aynı
  // formu submit ediyor.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || typeof form.matches !== 'function' || !form.matches(SEARCH_FORM)) return;

    var input = form.querySelector('input[name="q"]');
    if (!input) return;

    var terms = input.value.trim();
    if (!terms || isScoped(terms)) return;

    var url = scopedUrl(form.getAttribute('action') || '/search', terms);
    if (!url) return;

    event.preventDefault();
    window.location.assign(url);
  });

  // Öngörülü kutudaki arama önerileri ve "en çok aranan kelimeler" bağlantıları.
  // Zaten kapsamlı olan bağlantılar (filtre, sayfalama) dokunulmadan geçiyor.
  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    var link = event.target.closest('a[href*="q="]');
    if (!link || link.getAttribute('href').indexOf('/search') === -1) return;

    var url;
    try {
      url = new URL(link.href, window.location.origin);
    } catch (error) {
      return;
    }

    var terms = (url.searchParams.get('q') || '').trim();
    if (!terms || isScoped(terms) || url.searchParams.get(BROAD_PARAM)) return;

    var scoped = scopedUrl(url.pathname, terms);
    if (!scoped) return;

    event.preventDefault();
    window.location.assign(scoped);
  });

  function replaceText(root, from, to) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var nodes = [];

    while (walker.nextNode()) {
      if (walker.currentNode.nodeValue.indexOf(from) !== -1) nodes.push(walker.currentNode);
    }

    nodes.forEach(function (node) {
      node.nodeValue = node.nodeValue.split(from).join(to);
    });
  }

  // Adres çubuğundaki ham sorgu kullanıcıya gösterilmemeli: arama kutusunu,
  // sekme başlığını ve sayfa üstündeki metinleri yazdığı terime çeviriyoruz.
  function restoreDisplayTerms() {
    var terms = displayTerms();
    if (!terms) return;

    document.querySelectorAll(SEARCH_FORM + ' input[name="q"]').forEach(function (input) {
      input.value = terms;
    });

    var raw = param('q');
    if (!raw) return;

    if (document.title.indexOf(raw) !== -1) {
      document.title = document.title.split(raw).join(terms);
    }

    document.querySelectorAll('.template-search__header, .collection__toolbar').forEach(function (root) {
      replaceText(root, raw, terms);
    });
  }

  // Kapsamlı arama boş döndüyse tam metin aramaya geçiş bağlantısını açıyoruz.
  function offerBroaderSearch() {
    var terms = displayTerms();
    var fallback = document.getElementById('SearchBroaden');
    if (!terms || !fallback || document.getElementById('ProductsList')) return;

    var link = fallback.querySelector('a');
    if (!link) return;

    link.href =
      link.getAttribute('href') + '?q=' + encodeURIComponent(terms) + '&' + BROAD_PARAM + '=1';
    fallback.hidden = false;
  }

  // Yer imleri, dış bağlantılar ve uygulamalardan gelen kapsamsız /search
  // adresleri de aynı sonuçları vermeli. `all=1` taşıyan adresler —geniş arama
  // bağlantısı— dokunulmadan geçiyor, yoksa sonsuz döngü olurdu.
  function upgradePlainSearch() {
    var raw = param('q');
    if (!raw || param(BROAD_PARAM) || isScoped(raw)) return false;
    if (!document.querySelector('.template-search')) return false;

    var url = scopedUrl(window.location.pathname, raw.trim());
    if (!url) return false;

    window.location.replace(url);
    return true;
  }

  function init() {
    if (upgradePlainSearch()) return;

    restoreDisplayTerms();
    offerBroaderSearch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.searchQueryScope = { scope: scope, isScoped: isScoped, scopedUrl: scopedUrl };
})();
